/* Account page licence card – see docs/features/customer-account.md */
(function (root) {
  var LicenceCard = {
    // The Renew button says "Renew" rather than "Renew early" once every
    // licence the /days fragment has a day count for has lapsed (card 6256):
    // data-days-remaining (Library, blank without a count) and
    // data-em-days-remaining (EasyMaker, absent without one).
    allLapsed: function (daysAttr, emDaysAttr) {
      var counts = [daysAttr, emDaysAttr]
        .map(function (attr) { return parseInt(attr, 10); })
        .filter(function (days) { return !isNaN(days); });
      return counts.length > 0 && counts.every(function (days) { return days < 0; });
    }
  };

  root.LicenceCard = LicenceCard;
  if (typeof module !== 'undefined' && module.exports) module.exports = LicenceCard;
})(typeof window !== 'undefined' ? window : globalThis);
